module.exports = __webpack_public_path__ + "static/media/MZ_02.d78a4594.jpg";